<template>
  <div style="padding:10px 10px 10px 10px;">
     <el-card>
      <div class="class_3">关键数据</div>
      <el-col :span="8">
        <div class="class_2">美钥码总数:</div>
        <div class="class_4">{{QrTotalNumber}}</div>
      </el-col>
      <el-col :span="8">
        <div class="class_2">网站美钥码总数:</div>
        <div class="class_4">{{WebQrNumber}}</div>
      </el-col>
      <el-col :span="8">
        <div class="class_2">文本美钥码总数:</div>
        <div class="class_4">{{TextQrNumber}}</div>
      </el-col>
    </el-card>
        <el-card style="margin-top:10px">
         
      <el-col :span="12">
        <div id="chartsArea0" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
  <div class="block">
    <el-date-picker v-model="selectedDate1" type="daterange" align="right" placeholder="选择日期范围" style="margin-left:10px;" :picker-options="pickerOptions1">
    </el-date-picker>
    <el-button class="class_5" @click="showChart(0)">统计</el-button>
  </div>

        <myTable prop1="qrid" prop2="scanNumber" label1="标签" label2="扫描次数"   width1="150" width2="150" width3="150" :dataForTable="dataForTable0"></myTable>
      </el-col>
    </el-card>

        <el-card style="margin-top:10px">
      <el-col :span="12">
        <div id="chartsArea3" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
  
        <div class="block">
          <el-date-picker v-model="selectedDate0" type="daterange" align="right" placeholder="选择日期范围" style="margin-left:10px;" :picker-options="pickerOptions1">
          </el-date-picker>
          <el-button class="class_5" @click="showChart(3)">统计</el-button>
        </div>
        <myTable prop1="province" prop2="scanNumber" label1="省份" label2="扫描总次数" prop3="calc" label3="百分比" width1="150" width2="150" width3="150" :dataForTable="dataForTable3"></myTable>
      </el-col>
    </el-card>

    <el-card style="margin-top:10px">
      <el-col :span="12">
        <div id="chartsArea1" style="width:100%;height:500px;"></div>
      </el-col>
            <el-col :span="12">
        <div id="chartsArea4" style="width:100%;height:500px;"></div>
      </el-col>
    </el-card>
    <el-card style="margin-top:10px">
      <el-col :span="12">
        <div id="chartsArea2" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
        <myTable prop1="qrid" prop2="number" label1="美钥码" label2="扫描次数" prop3="calc" label3="百分比" width1="250" width2="150" width3="150" :dataForTable="dataForTable2"></myTable>
      </el-col>
    </el-card> 
  </div>
</template>

<script>
import $ from 'jquery'
import echarts from 'echarts'
import myTable from './dataAnalysisTable.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    myTable
  },
  computed: {
    ...mapGetters(['qrlabelList'])
  },
  data () {
    return {
      QrTotalNumber: 0,
      WebQrNumber: 0,
      TextQrNumber: 0,
      dataForTable0: [],
      dataForTable1: [],
      dataForTable2: [],
      dataForTable3: [],
      selectedDate0: [new Date(new Date().getFullYear(), (new Date().getMonth() - 1), new Date().getDate()), new Date()],
      selectedDate1: [new Date(new Date().getFullYear(), (new Date().getMonth() - 1), new Date().getDate()), new Date()],
      pickerOptions1: { // 选择日期时候的快速选项
        shortcuts: [{
          text: '最近三天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      options: [
        // 柱状图 0
        {
          title: {
            text: '美钥码历史扫描次数排名',
            subtext: '根据扫描记录统计',
            left: 'center'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['扫描次数']
          },
          color: ['#f44f4b'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            itemSize: 40,
            itemGap: 30,
            feature: {
              magicType: {
                type: ['line', 'bar']
              },
              saveAsImage: {}
            },
            right: 20
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '扫描次数',
              type: 'bar',
              barWidth: '60%',
              data: []
            }
          ]
        },
        // 扇形图 1
        {
          title: {
            text: '美钥码种类统计',
            subtext: '根据扫描记录统计',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: []
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            // left: 'left',
            itemSize: 40,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          series: [
            {
              name: '美钥码种类',
              type: 'pie',
              radius: '50%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        },
        // 中国地图 2
        {
          title: {
            text: '美钥码扫描分布情况',
            subtext: '根据扫描信息统计',
            left: 'center'
          },
          color: [],
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: []
          },
          visualMap: {
            min: 0,
            max: 2500,
            left: 'left',
            top: 'bottom',
            text: ['高', '低'],
            calculable: true
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            // left: 'left',
            itemSize: 40,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          series: [
          ]
        },
        // 嵌套饼状图  3
        {
          title: {
            text: '美钥码扫描次数统计',
            left: 'center',
            subtext: '根据扫描记录统计'
          },
          color: ['#dddddd'],
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            x: 'left',
            data: []
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            // left: 'left',
            itemSize: 40,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          series: [
            {
              name: '标签',
              type: 'pie',
              selectedMode: 'single',
              radius: [0, '50%'],
              // label: {
              //   normal: {
              //     position: 'inner'
              //   }
              // },
              data: [0
              ]
            },
            {
              name: '美钥码扫描次数',
              type: 'pie',
              radius: ['60%', '70%'],
              label: {
                normal: {
                  position: 'inner'
                }
              },
              data: [
              ]
            }
          ]
        },
        // 横向条形图 4
        {
          title: {
            text: '标签下美钥码数量统计',
            subtext: '根据扫描记录统计',
            left: 'center'
          },
          color: ['#f44f4b'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            itemSize: 40,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          xAxis: [
            {
              type: 'value'
            }
          ],
          yAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          series: [
            {
              name: '美钥码数量',
              type: 'bar',
              barWidth: '60%',
              data: [10, 52, 200, 334, 390, 330, 220]
            }
          ]
        }
      ]
    }
  },
  mounted () {
    const vm = this
    vm.initChart()
    vm.showChart(0)
    vm.showChart(3)
  },
  methods: {
    initChart () {
      const vm = this
      vm.myChart0 = echarts.init(vm.$el.querySelector('#chartsArea0'))
      vm.myChart1 = echarts.init(vm.$el.querySelector('#chartsArea1'))
      vm.myChart2 = echarts.init(vm.$el.querySelector('#chartsArea2'))
      vm.myChart3 = echarts.init(vm.$el.querySelector('#chartsArea3'))
      vm.myChart4 = echarts.init(vm.$el.querySelector('#chartsArea4'))
      // 给饼状图添加点击事件
      /*
      vm.myChart0.on('click', function (params) {
        if (params.seriesIndex === 0) {
          vm.options[3].color = []
          vm.options[3].series[1].data = []
          vm.dataForTable0 = []
          vm.myChart0.showLoading()
          let sum = 0
          let from = vm.selectedDate1[0].getFullYear() + '-' + (vm.selectedDate1[0].getMonth() + 1) + '-' + vm.selectedDate1[0].getDate()
          let to = vm.selectedDate1[1].getFullYear() + '-' + (vm.selectedDate1[1].getMonth() + 1) + '-' + vm.selectedDate1[1].setDate(vm.selectedDate1[1].getDate() + 1)
          $.ajax({
            type: 'GET',
            url: '/v1/charts/fewDayScanNumberByLabelId',
            async: false,
            data: {
              from: from,
              to: to,
              labelId: vm.qrlabelList[params.dataIndex].id
            },
            dataType: 'json',
            success: function (response) {
              for (let i = 0; i < response.data.length; i++) {
                let temp = { name: response.data[i].qrid, value: Number(response.data[i].scanNumber) }
                vm.options[3].series[1].data.push(temp)
                let name = ''
                if (response.data[i].qrname === '') {
                  name = '未命名' + '(' + (String)(response.data[i].qrid) + ')'
                } else {
                  name = (String)(response.data[i].qrname) + '(' + (String)(response.data[i].qrid) + ')'
                }
                temp = {qrid: name, scanNumber: response.data[i].scanNumber}
                sum = sum + parseInt(response.data[i].scanNumber)
                vm.dataForTable0.push(temp)
              }
              for (i = 0; i < vm.dataForTable0.length; i++) {
                vm.dataForTable0[i].calc = Math.round((vm.dataForTable0[i].scanNumber / sum) * 100) + '%'
              }
              vm.myChart0.hideLoading()
              vm.myChart0.setOption(vm.options[3])
            }
          })
        }
      }) */
      // 添加标签到legend
      for (let i = 0; i < vm.qrlabelList.length; i++) {
        vm.options[2].series.push({
          name: 'label1',
          type: 'map',
          mapType: 'china',
          roam: false,
          label: {
            normal: {
              show: true
            },
            emphasis: {
              show: true
            }
          },
          data: []
        })
        vm.options[2].color.push(vm.qrlabelList[i].color)
        vm.options[2].legend.data.push(vm.qrlabelList[i].textDesc)
        vm.options[2].series[i].name = vm.qrlabelList[i].textDesc
      }
      // 这里由于可能标签很多导致卡顿，先不发送请求
      // vm.showChart(0)
      vm.myChart0.setOption(vm.options[3])
      vm.showChart(1)
      vm.showChart(2)
      // vm.showChart(3)
      vm.myChart3.setOption(vm.options[2])
      vm.showChart(4)
    },
    showChart (val) {
      const vm = this
      if (val === 0) {
        let allZero = true
        vm.options[3].color = []
        vm.options[3].legend.data = []
        vm.options[3].series[0].data = []
        vm.options[3].series[1].data = []
        vm.dataForTable0 = []
        // vm.myChart0.showLoading()
        let from = vm.selectedDate1[0].getFullYear() + '-' + (vm.selectedDate1[0].getMonth() + 1) + '-' + vm.selectedDate1[0].getDate()
        let to = vm.selectedDate1[1].getFullYear() + '-' + (vm.selectedDate1[1].getMonth() + 1) + '-' + vm.selectedDate1[1].getDate()
        for (let i = 0; i < vm.qrlabelList.length; i++) {
          $.ajax({
            type: 'GET',
            url: '/v1/charts/fewDayScanNumberByLabelId',
            async: false,
            data: {
              from: from,
              to: to,
              labelId: vm.qrlabelList[i].id
            },
            dataType: 'json',
            success: function (response) {
              // let name = ''
              // if (response.data[i].qrname === '') {
              //   name = '未命名' + '(' + (String)(response.data[i].qrid) + ')'
              // } else {
              //   name = (String)(response.data[i].qrname) + '(' + (String)(response.data[i].qrid) + ')'
              // }
              // temp = {qrid: name, scanNumber: response.data[i].scanNumber}

              // for (j = 0; j < response.data.length; j++) {
              //   let temp2 = {qrid: response.data[j].qrid, scanNumber: response.data[j].scanNumber}
              //   vm.dataForTable0.push(temp2)
              // }
              // let temp2 = {qrid: name, scanNumber: response.data[i].scanNumber}
              vm.options[3].color.push(vm.qrlabelList[i].color)
              vm.options[3].legend.data.push(vm.qrlabelList[i].textDesc)
              let sumOfScanNumber = 0
              for (let j = 0; j < response.data.length; j++) {
                sumOfScanNumber = sumOfScanNumber + Number(response.data[j].scanNumber)
              }
              if (sumOfScanNumber !== 0) {
                allZero = false
              }
              let temp = {name: vm.qrlabelList[i].textDesc, value: sumOfScanNumber}
              if (sumOfScanNumber !== 0) {
                vm.options[3].series[0].data.push(temp)
              }
              temp = {qrid: vm.qrlabelList[i].textDesc, scanNumber: sumOfScanNumber}
              vm.dataForTable0.push(temp)
            }
          })
        }
        // vm.myChart0.hideLoading()
        vm.options[3].title.subtext = '(' + from + '至' + to + ')'
        if (allZero === true) {
          vm.options[3].series[0].data = []
          vm.options[3].series[1].data = []
          vm.options[3].series[0].data.push(0)
          vm.options[3].color = []
          vm.options[3].legend.data = []
          vm.options[3].color.push('#dddddd')
        }
        vm.myChart0.setOption(vm.options[3])
      } else if (val === 1) {
        vm.myChart1.showLoading()
        $.ajax({
          type: 'GET',
          url: '/v1/charts/getQrNumberAndType',
          async: false,
          data: {},
          dataType: 'json',
          success: function (response) {
            vm.QrTotalNumber = response.data[0]
            vm.WebQrNumber = response.data[1]
            vm.TextQrNumber = response.data[2]
            let temp = { name: '网站', value: response.data[1] }
            vm.options[1].series[0].data.push(temp)
            temp = { name: '文本', value: response.data[2] }
            vm.options[1].series[0].data.push(temp)
            vm.myChart1.hideLoading()
            vm.myChart1.setOption(vm.options[1])
          }
        })
      } else if (val === 2) {
        vm.myChart2.showLoading()
        $.ajax({
          type: 'GET',
          url: '/v1/charts/findTopByUserOrderByQrscancountDesc',
          data: {},
          dataType: 'json',
          success: function (response) {
            vm.options[0].series[0].data = []
            vm.options[0].xAxis[0].data = []
            for (let i = 0; i < response.data.length; i++) {
              vm.options[0].series[0].data.push(response.data[i].scanNumber)
              vm.options[0].xAxis[0].data.push(response.data[i].qrid)
              let name = ''
              if (response.data[i].qrname === '') {
                name = '未命名' + '(' + (String)(vm.getNewQrId(response.data[i].qrid, response.data[i].qrType)) + ')'
              } else {
                name = (String)(response.data[i].qrname) + '(' + (String)(vm.getNewQrId(response.data[i].qrid, response.data[i].qrType)) + ')'
              }
              let temp = { qrid: name, number: parseInt(response.data[i].scanNumber) }
              vm.dataForTable2.push(temp)
            }
            let sum = 0
            for (let j = 0; j < vm.dataForTable2.length; j++) {
              sum = sum + (vm.dataForTable2[j].number)
            }
            for (let j = 0; j < vm.dataForTable2.length; j++) {
              vm.dataForTable2[j].calc = Math.round((vm.dataForTable2[j].number / sum) * 100) + '%'
            }
            vm.myChart2.hideLoading()
            vm.myChart2.setOption(vm.options[0])
          }
        })
      } else if (val === 3) {
        let maxNumberOfMap = 0
        vm.dataForTable3 = []
        let from = vm.selectedDate0[0].getFullYear() + '-' + (vm.selectedDate0[0].getMonth() + 1) + '-' + vm.selectedDate0[0].getDate()
        let to = vm.selectedDate0[1].getFullYear() + '-' + (vm.selectedDate0[1].getMonth() + 1) + '-' + vm.selectedDate0[1].getDate()
        // vm.myChart3.showLoading()
        for (let i = 0; i < vm.qrlabelList.length; i++) {
          vm.options[2].series[i].data = []
          $.ajax({
            type: 'get',
            url: '/v1/charts/countByLabelAndProvinceAndDate',
            async: false,
            data: {
              labelId: vm.qrlabelList[i].id,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              for (let j = 0; j < response.data.length; j++) {
                if (response.data[j].province === 'unknown') {
                  continue
                }
                let temp = {name: response.data[j].province, value: response.data[j].scanNumber}
                vm.options[2].series[i].data.push(temp)
                if (Number(response.data[j].scanNumber) > maxNumberOfMap && response.data[j].province !== 'unknown') {
                  maxNumberOfMap = Number(response.data[j].scanNumber)
                }
                let find = false
                let k = 0
                for (k = 0; k < vm.dataForTable3.length; k++) {
                  if (vm.dataForTable3[k].province === response.data[j].province) {
                    find = true
                    vm.dataForTable3[k].scanNumber = vm.dataForTable3[k].scanNumber + Number(response.data[j].scanNumber)
                    break
                  }
                }
                if (find === false) {
                  temp = { province: response.data[j].province, scanNumber: Number(response.data[j].scanNumber) }
                  vm.dataForTable3.push(temp)
                }
                if (vm.dataForTable3[k].scanNumber > maxNumberOfMap && vm.dataForTable3[k].province !== 'unknown') {
                  maxNumberOfMap = vm.dataForTable3[k].scanNumber
                }
              }
              let sum = 0
              for (let j = 0; j < vm.dataForTable3.length; j++) {
                sum = sum + (vm.dataForTable3[j].scanNumber)
              }
              for (let j = 0; j < vm.dataForTable3.length; j++) {
                vm.dataForTable3[j].calc = Math.round((vm.dataForTable3[j].scanNumber / sum) * 100) + '%'
              }
              vm.options[2].visualMap.max = maxNumberOfMap
              // vm.myChart3.hideLoading()
              vm.options[2].title.subtext = '(' + from + '至' + to + ')'
              if (vm.options[2].visualMap.max === 0) {
                vm.options[2].visualMap.max = 5
              }
              vm.myChart3.setOption(vm.options[2])
            }
          })
        }
      } else if (val === 4) {
        vm.myChart4.showLoading()
        vm.options[4].yAxis[0].data = []
        vm.options[4].series[0].data = []
        for (let i = 0; i < vm.qrlabelList.length; i++) {
          vm.options[4].yAxis[0].data.push(vm.qrlabelList[i].textDesc)
          vm.options[4].series[0].data.push(vm.qrlabelList[i].num)
          vm.dataForTable1.push({qrType: vm.qrlabelList[i].textDesc, number: vm.qrlabelList[i].num, calc: Math.round((vm.qrlabelList[i].num / vm.QrTotalNumber) * 100)})
        }
        vm.myChart4.hideLoading()
        vm.myChart4.setOption(vm.options[4])
      }
    }
  }
}
</script>

